import { render, staticRenderFns } from "./MethodCode.vue?vue&type=template&id=9fce5ed6&scoped=true&"
import script from "./MethodCode.vue?vue&type=script&lang=js&"
export * from "./MethodCode.vue?vue&type=script&lang=js&"
import style0 from "./MethodCode.vue?vue&type=style&index=0&id=9fce5ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fce5ed6",
  null
  
)

export default component.exports